<template>
  <div
    class="mb-6 list-disc rounded border-2 border-red-500 bg-white p-2 shadow-black drop-shadow-xl"
    aria-live="polite"
    v-if="Object.keys(errors).length > 0"
  >
    <TransitionGroup
      tag="ul"
      leave-to-class="opacity-0"
      leave-active-class="transition-opacity duration-700"
      class="list-inside list-disc"
    >
      <template v-for="(value, key) in errors" :key="key">
        <li v-for="message in value" :key="message">{{ message }}</li>
      </template>
    </TransitionGroup>
  </div>
  <form class="flex w-full flex-col gap-2">
    <InputText
      class="rounded"
      :value="parameters.name"
      :error="errors.hasOwnProperty('name')"
      :error-message="getErrorMessage('name')"
      @change="
        (event) => changeParameter({ key: 'name', value: event.target.value })
      "
      name="name"
      aria-required="true"
      placeholder="Name *"
      type="text"
    />
    <InputText
      class="rounded"
      :value="parameters.company"
      @change="
        (event) =>
          changeParameter({ key: 'company', value: event.target.value })
      "
      name="company"
      placeholder="Company"
      type="text"
    />
    <InputText
      class="rounded"
      :value="parameters.website"
      @change="
        (event) =>
          changeParameter({ key: 'website', value: event.target.value })
      "
      name="website"
      placeholder="Website"
      type="text"
    />
    <InputText
      class="rounded"
      :value="parameters.email"
      :error="errors.hasOwnProperty('email')"
      :error-message="getErrorMessage('email')"
      @change="
        (event) => changeParameter({ key: 'email', value: event.target.value })
      "
      name="email"
      aria-required="true"
      placeholder="Email *"
      type="email"
    />
    <InputText
      class="rounded"
      :value="parameters.telephone"
      @change="
        (event) =>
          changeParameter({ key: 'telephone', value: event.target.value })
      "
      name="telephone"
      placeholder="Telephone"
    />
    <InputText
      class="rounded"
      :value="parameters.subject"
      :error="errors.hasOwnProperty('subject')"
      :error-message="getErrorMessage('subject')"
      @change="
        (event) =>
          changeParameter({ key: 'subject', value: event.target.value })
      "
      name="subject"
      aria-required="true"
      placeholder="Subject *"
      type="text"
    />
    <InputText
      class="rounded"
      :value="parameters.enquiry"
      :error="errors.hasOwnProperty('enquiry')"
      :error-message="getErrorMessage('enquiry')"
      @change="
        (event) =>
          changeParameter({ key: 'enquiry', value: event.target.value })
      "
      name="enquiry"
      aria-required="true"
      placeholder="Enquiry *"
      type="text"
    />
    <input-button
      block
      class="rounded"
      styleType="secondary"
      @onClick="this.$emit('submit')"
      :disabled="submitting"
    >
      Contact Us
    </input-button>
  </form>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import InputText from 'Components/InputText.vue';

export default {
  name: 'ContactUsForm',
  components: {
    InputButton,
    InputText,
  },
  props: {
    parameters: {
      type: Object,
      default: {},
    },
    errors: {
      type: Object,
      default: {},
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeParameter({ key, value }) {
      this.$emit('changeParameter', { key, value });
    },
    getErrorMessage(key) {
      if (
        !this.errors.hasOwnProperty(key) ||
        !this.errors[key] instanceof Array
      ) {
        return;
      }
      // Errors returned by the API is a list of strings for each validation failed. Join the validation messages
      // together into a single string.
      return this.errors[key].join(' ');
    },
  },
};
</script>
